import { render, staticRenderFns } from "./factsDialog.vue?vue&type=template&id=e81f72cc&scoped=true"
import script from "./factsDialog.vue?vue&type=script&lang=js"
export * from "./factsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81f72cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e81f72cc')) {
      api.createRecord('e81f72cc', component.options)
    } else {
      api.reload('e81f72cc', component.options)
    }
    module.hot.accept("./factsDialog.vue?vue&type=template&id=e81f72cc&scoped=true", function () {
      api.rerender('e81f72cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/AAA/dialog/factsDialog.vue"
export default component.exports